'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getBridge = function getBridge() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var internalBridgeName = options.bridgeName || '_dsbridge';
  var internalBridge = window[internalBridgeName];
  if (!internalBridge) {
    throw new Error('No injected global bridge object.');
  }

  var log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (options.debug) {
      var _console;

      // eslint-disable-next-line no-console
      (_console = console).log.apply(_console, ['[bridge]'].concat(args));
    }
  };
  var jsBridge = {
    handlerMap: {},
    callHandler: function callHandler(name, args) {
      args = JSON.stringify(args || {});
      log('callHandler', name, args);

      var ret = '';
      // Kepler
      if (internalBridge.kepler) {
        return internalBridge.callHandler(name, args);
        // WKWebview
      } else if (internalBridge.wk) {
        ret = prompt(internalBridgeName + '=' + name, args);
      } else {
        ret = internalBridge.callHandler(name, args);
        log('callHandler result', ret);
      }
      return new Promise(function (resolve, reject) {
        if (ret) {
          ret = JSON.parse(ret);
          if (ret.error) {
            return reject(new Error(ret.error));
          }
          return resolve(ret.result);
        }
        return resolve(ret);
      });
    },
    registerHandler: function registerHandler(name, handler) {
      jsBridge.handlerMap[name] = handler;
    },
    init: function init() {
      log('init');
      if (internalBridge.wk) {
        prompt(internalBridgeName + 'init=');
      } else {
        internalBridge.init();
      }
    }
  };

  // extend internal bridge
  internalBridge.invokeHandler = function (name, args, callbackId) {
    var handler = jsBridge.handlerMap[name];
    if (!handler) {
      throw new Error('No js handler named "' + name + '" registered.');
    }

    var sendResponse = function sendResponse(result) {
      if (typeof callbackId !== 'number') return;
      log('invokeHandler sendResponse', name, args, callbackId, result);
      if (internalBridge.wk) {
        prompt(internalBridgeName + 'cid=' + callbackId, result);
      } else {
        internalBridge.returnValue(callbackId, result);
      }
    };

    if (handler.length === 2) {
      // async handler
      handler(args, function (response) {
        sendResponse(JSON.stringify(response));
      });
    } else {
      var response = {};
      try {
        response.result = handler(args);
      } catch (ex) {
        response.error = ex.toString();
      }
      sendResponse(JSON.stringify(response));
    }
  };
  return jsBridge;
};

exports.getBridge = getBridge;
